import * as React from 'react';
import { useSelector } from '@grandvisionhq/state';
import { getPrescriptionType, hasVisitedStepPrescription } from '../../../../state/configurator/selectors.js';
import { useRxGlassesConfiguratorContext } from '../../../Context/RxGlassesConfiguratorContext.js';
import { RxGlassesExpanderContent } from './RxGlassesExpanderContent.js';

const RxGlassesExpanderContentContainer = ()=>{
    const { id  } = useRxGlassesConfiguratorContext();
    const prescriptionType = useSelector(getPrescriptionType);
    const hasVisitedStepPrescription$1 = useSelector((s)=>hasVisitedStepPrescription(s, {
            id
        })
    );
    return /*#__PURE__*/ React.createElement(RxGlassesExpanderContent, {
        prescriptionType: prescriptionType,
        hasVisitedStepPrescription: hasVisitedStepPrescription$1
    });
};

export { RxGlassesExpanderContentContainer };
//# sourceMappingURL=RxGlassesExpanderContentContainer.js.map
